
import { ProviderModel } from '@alao-frontend/erp-services'
import { Component, Vue, namespace } from 'nuxt-property-decorator'
import BlackFridayProvider from '~/components/black-friday/BlackFridayProvider.vue'
import { namespace as baseInfoStore, GetterType as BaseInfoGetterType, BaseInfoState } from '~/store/modules/BaseInfo'

const AVAILABLE_PROVIDERS = ['swisscom', 'salt', 'wingo', 'yallo', 'migros-mobile', 'quickline', 'talktalk', 'spusu', 'mtel']

const BaseInfoStore = namespace(baseInfoStore)

@Component({
  components: {
    BlackFridayProvider,
  },
})
export default class BlackFridayProviders extends Vue {
  get providers () {
    return AVAILABLE_PROVIDERS.map((slug) => {
      const provider: ProviderModel | undefined = this.$store.getters[`${baseInfoStore}/${BaseInfoGetterType.PROVIDER_BY_SLUG}`](slug)

      if (!provider) {
        return null
      }

      return {
        text: this.$t('blackFriday.providers.link', {
          name: provider.title,
        }),
        url: this.localePath({
          name: 'black-friday-slug',
          params: {
            slug: provider.slug,
          },
        }),
        imgSrc: provider.logo.w200,
        linkText: this.$t('blackFriday.index.compare.button'),
        imgAlt: provider.title,
      }
    }).filter(Boolean)
  }
}
